import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

import { PaginationControlsComponent } from 'ngx-pagination';
import { NgxPaginationModule } from 'ngx-pagination';
import { SharedModule } from '../shared/shared.module';
import { HttpClientModule } from '@angular/common/http';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { AutocompleteLibModule } from 'angular-ng-autocomplete';

import { RolePermissionComponent } from '../role-permission/role-permission.component';
import { UserRolePermissionComponent } from '../role-permission/user-role-permission/user-role-permission.component';

const routes: Routes = [
  { path: '', component: RolePermissionComponent },
  { path: 'role-permission', component: RolePermissionComponent },
  { path: 'user-role-permission', component: UserRolePermissionComponent },
];

@NgModule({
  declarations: [
    RolePermissionComponent,
    UserRolePermissionComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    NgbModule,
    FormsModule,
    NgxPaginationModule,
    RouterModule.forChild(routes),
    SharedModule,
    ReactiveFormsModule,
    HttpClientModule,
    AngularSvgIconModule.forRoot(),
    AutocompleteLibModule,
    NgSelectModule,
  ]
})
export class RolepermissionModule { }
